import { Fragment, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import { Dialog, Transition, TransitionChild } from '@headlessui/react';
import { useQuoteStore, useTripStore } from '@store';

import { QuoteError } from './quoteError/quoteError.component';
import { QuoteLoading } from './quoteLoading/quoteLoading.component';
import { QuoteRetry } from './quoteRetry/quoteRetry.component';

export const GetQuoteLoading = () => {
  const quoteLoadingType = useQuoteStore(state => state.quoteLoadingType);
  const isCreatingOrUpdatingTrip = useTripStore(state => state.isCreatingOrUpdatingTrip);

  const renderContent = useMemo(() => {
    switch (quoteLoadingType.type) {
      case 'quoteLoading':
        return <QuoteLoading />;
      case 'quoteRetry':
        return <QuoteRetry />;
      default:
        return <QuoteError />;
    }
  }, [quoteLoadingType.type]);

  const bgColor = quoteLoadingType.type === 'quoteLoading' ? 'bg-mono-100' : 'bg-nusa-100';

  const isError = quoteLoadingType.type === 'quoteRetry' || quoteLoadingType.type === 'quoteError';

  const isOpen = isCreatingOrUpdatingTrip || isError;

  return (
    <Transition show={isOpen}>
      <Dialog open={isOpen} as="div" className="relative z-10" onClose={v => v}>
        <div className="fixed inset-0 overflow-y-auto">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95">
            <Dialog.Panel
              className={twMerge(
                'w-screen h-screen flex items-center justify-center px-2 md:px-0',
                bgColor,
              )}>
              {renderContent}
            </Dialog.Panel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};
